import { AdPull, setInstance } from "./instance";
export const create = (option) => {
    const instance = new AdPull();
    if (option.isPremium) {
        instance.isPremium = option.isPremium;
    }
    instance.platform = option.platform;
    instance.userId = option.userId;
    setInstance(instance);
    return instance;
};
//# sourceMappingURL=create.js.map